import { useEffect, useRef, useState } from "react";

export const useCountdown = ({ onFinish, timeInterval = 1000 }: { onFinish?: () => void, timeInterval ?: number }) => {
  const [timeLeft, setTimeLeft] = useState<number | undefined>(undefined);
  const intervalRef = useRef<NodeJS.Timer>(undefined);

  const initTimer = () => {
    if (timeLeft === undefined) {
      return
    }
    if (timeLeft === 0) {
      onFinish?.()
      return
    }
    setTimeout(() => {
      setTimeLeft(timeLeft - 1)
    }, timeInterval)
  };

  useEffect(() => {
    if (timeLeft === undefined) {
      return
    }
    initTimer()
    return () => clearInterval(intervalRef.current);
  }, [timeLeft]);

  const formatTime = () => {
    const time = timeLeft;
    if (time === undefined) {
      return "-";
    }
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
  };

  const startTimer = (timer: number) => {
    setTimeLeft(timer); // time in seconds
  };

  return { timeLeft, formatTime, startTimer };
};
